/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Table, TableSkeleton } from '../../common/Table';
import { SigningProcess, SigningProcessesResponse } from '../types';
import { signingProcessesTableColumns } from './SigningProcessesTableColumns';
import { Pagination } from '../../common/Pagination';

function SigningProcessesTableEmptyState() {
  return (
    <div className="card shadow-sm p-4">
      <div className="card-body text-center py-8 d-flex flex-column align-items-center gap-2">
        <img
          src="/static/img/illustrations/profile-analysis.svg"
          alt="Ilustración de una mujer y un hombre observando con una lupa un documento grande, simbolizando análisis o revisión detallada de información."
          height={178}
          width={178}
        />
        <h6 className="text-primary"> Aún no tienes documentos</h6>
        <span className="text-gray-blue-400">
          Una vez que tengas documentos pendientes, aparecerán aquí
        </span>
      </div>
    </div>
  );
}

function SigningProcessesTableErrorState() {
  return (
    <div className="card shadow-sm p-4">
      <div className="card-body text-center py-8 d-flex flex-column align-items-center gap-2">
        <img
          src="/static/img/illustrations/desktop-error.svg"
          alt="Mujer sentada frente a una pantalla con gráficos, junto a un ícono de equis que indica error o resultado incorrecto."
          height={178}
          width={178}
        />
        <h6 className="text-primary"> Ocurrió un error</h6>
        <span className="text-gray-blue-400">
          Por favor, recarga la página. Si el problema persiste, contacta al soporte.
        </span>
      </div>
    </div>
  );
}

interface SigningProcessesTableProps {
  data: SigningProcessesResponse | null;
  isLoading: boolean;
  isError: boolean;
  currentPage: number;
  onPageChange: (page: number) => void;
  totalPages: number;
  isSuperuser: boolean;
  isReadOnly: boolean;
}

export function SigningProcessesTable({
  data,
  isLoading,
  isError,
  currentPage,
  onPageChange,
  totalPages,
  isSuperuser,
  isReadOnly,
}: SigningProcessesTableProps) {
  if (isLoading) return <TableSkeleton columns={signingProcessesTableColumns.length} rows={10} />;
  if (isError) return <SigningProcessesTableErrorState />;
  if (!data) return null;

  return (
    <>
      <Table<SigningProcess>
        data={data.results}
        emptyState={<SigningProcessesTableEmptyState />}
        columns={signingProcessesTableColumns(isReadOnly, isSuperuser)}
        columnVisibility={{
          executive: isSuperuser || isReadOnly,
        }}
        rowKey={(row) => row.id}
        responsive
      />
      <div className="row align-items-center mb-2">
        <div className="col-sm-12">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
        </div>
      </div>
    </>
  );
}
